// Google verification code usage guide page translations
export default {
  title: "How to Use Google Verification Code",

  // WeChat Mini Program usage method
  wechatMethod: {
    title: "1. WeChat Mini Program",
    step1:
      'Step 1: Search for "Tencent Authenticator" or "NingDun Token" on WeChat to enter the mini program',
    step2:
      "Step 2: Please enter the dynamic number you bound in the mini program into the verification code input box",
  },

  // Mobile App usage method
  appMethod: {
    title:
      "2. Mobile NingDun Token (iOS and Android users) or Google Authenticator (iOS users only)",
    step1:
      "Step 1: Search for the corresponding app in the App Store or Android app market and download it",
    step2:
      "Step 2: Please enter the dynamic number you bound in the App into the verification code input box",
  },
};
